<template>
  <div class="bg-light min-vh-100">
    <main class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="card shadow-sm">
            <div class="card-body">
              <h1 class="h4 mb-2">New Customer</h1>
              <p class="help mb-3">Create a new customer record.</p>

              <form @submit.prevent="handleCreate">
                <div class="mb-3">
                  <label class="form-label">Name *</label>
                  <input v-model="form.customer_name" type="text" class="form-control" required />
                </div>

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">Email</label>
                    <input v-model="form.email" type="email" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Phone</label>
                    <input v-model="form.phone" type="text" class="form-control" />
                  </div>
                </div>

                <div class="mt-3">
                  <label class="form-label">Address</label>
                  <input v-model="form.address" type="text" class="form-control" />
                </div>

                <div class="mt-3">
                  <label class="form-label">Notes</label>
                  <textarea v-model="form.notes" class="form-control" rows="2"></textarea>
                </div>

                <div v-if="error" class="alert alert-danger py-2 mt-3">{{ error }}</div>

                <div class="d-flex gap-2 mt-4">
                  <button type="button" class="btn btn-outline-secondary" @click="$router.push({ name: 'CustomersList' })">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                    Create Customer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { APIService } from "../http/APIService";

export default {
  name: "CreateCustomer",
  data() {
    return {
      form: {
        customer_name: "",
        email: "",
        phone: "",
        address: "",
        notes: "",
      },
      loading: false,
      error: null,
      api: new APIService(),
    };
  },
  methods: {
    async handleCreate() {
      this.error = null;
      this.loading = true;
      try {
        const accessToken = localStorage.getItem("accessToken");
        const res = await this.api.createCustomer(this.form, accessToken);
        const id = res.data?.customer_id;
        if (id) {
          this.$router.push({ name: "CustomerDetail", params: { id } });
        } else {
          this.$router.push({ name: "CustomersList" });
        }
      } catch {
        this.error = "Unable to create customer.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
